import { render, staticRenderFns } from "./Http404.vue?vue&type=template&id=18a76a36&scoped=true"
import script from "./Http404.vue?vue&type=script&lang=js"
export * from "./Http404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a76a36",
  null
  
)

export default component.exports